import NeoparentLayout from "./NeoparentLayout";
import NeoparentDashboardLayout from "./NeoparentDashboardLayout";
import RestrictedLayout from "@/layouts/RestrictedLayout";

const LayoutsPlugin = {
  install(Vue) {
    Vue.component(NeoparentLayout.name, NeoparentLayout)
    Vue.component(NeoparentDashboardLayout.name, NeoparentDashboardLayout)
    Vue.component(RestrictedLayout.name, RestrictedLayout)
  }
}

export { LayoutsPlugin }
